<div class="app-cit-pla-exp">
  <div
    class="app-cit-pla-exp__bar"
    [ngStyle]="{ color: expanded() ? '#000' : '#A0A0A0', 'font-weight': expanded() ? '600' : '400' }"
    (click)="expanded.set(!expanded())"
  >
    {{ day().title }}
    <img
      class="app-cit-pla-exp__bar__arr"
      [ngStyle]="{ transform: expanded() ? 'rotate(180deg)' : 'rotate(0)' }"
      [src]="expanded() ? 'assets/images/pages/cities/exp-black.svg' : 'assets/images/pages/cities/exp.svg'"
    />
  </div>

  @if (expanded()) {
    <div class="app-cit-pla-exp__con" [appAnimate]="'landing'" [speed]="'fast'" [aos]="0.5">
      <ul>
        @for (l of day().list; track $index) {
          <li>{{ l }}</li>
        }
      </ul>
    </div>
  }
</div>
